import { useState, useEffect } from 'react';
import { getCurrentWebsiteTheme, applyWebsiteTheme } from '../utils/updateWebsiteTheme';

const useWebsiteTheme = () => {
  const [currentTheme, setCurrentTheme] = useState(null);

  useEffect(() => {
    // Initialize theme
    const theme = getCurrentWebsiteTheme();
    setCurrentTheme(theme);
    applyWebsiteTheme(theme);

    // Listen for storage changes (cross-tab updates)
    const handleStorageChange = (e) => {
      if (e.key === 'website_color_scheme') {
        try {
          const newTheme = JSON.parse(e.newValue);
          setCurrentTheme(newTheme);
          applyWebsiteTheme(newTheme);
        } catch (error) {
          console.error('Error parsing theme from storage:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const updateTheme = (scheme) => {
    setCurrentTheme(scheme);
    applyWebsiteTheme(scheme);
  };

  return {
    currentTheme,
    updateTheme,
  };
};

export default useWebsiteTheme;